<template>
  <div class="buy">
    <img src="../assets/buy.png" mode="widthFix" class="buy_image" />
    <div class="buy_body flex">
      <div class="body_item">
        <img src="../assets/menu1.png" alt="">
        <div class="body_title">搜索小程序名称 进入“首页”</div>
      </div>
      <div class="body_item">
        <img src="../assets/menu2.png" alt="">
        <div class="body_title">嗨淘低价好书</div>
      </div>
      <div class="body_item">
        <img src="../assets/menu4.png" alt="">
        <div class="body_title">添加到购物车支付书款</div>
      </div>
      <div class="body_item">
        <img src="../assets/menu3.png" alt="">
        <div class="body_title">等待快递 送货上门</div>
      </div>
    </div>
    <div class="buy_foot">
      <div class="foot_label">买书答疑A&Q </div>
      <div v-for="(item,index) in list" :key="index">
        <div class="foot_title">{{item.question}}</div>
        <div class="foot_item">{{item.answer}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Buy",
  data() {
    return {
       list: [],
    };
  },
  methods: {
    // 获取问答列表
    sysData() {
      this.$getRequest("/sysData",{
        key:'buy_question_answer'
      }).then((res) => {
        this.list = res.data;
      });
    }
  },
  created(){
    this.sysData();
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>
<style lang="scss" scoped>
.buy_foot {
  width: 100%;
  min-height: 1091px;
  background: #fffaf4;
  padding: 61px 260px 78px;
  box-sizing: border-box;
  text-align: left;
  .foot_label {
    font-size: 45px;
    color: #447849;
  }
  .foot_title {
    font-size: 30px;
    font-weight: bold;
    margin: 29px 0;
  }
  .foot_item {
    font-size: 25px;
    width: 1400px;
    background: #FFF6EB;
    padding: 33px 18px 33px 57px;
  }
}
.buy_body {
  width: 100%;
  height: 655px;
  background-color: #ffffff;
  .body_item {
    text-align: center;
    width: 315px;
    margin-left: 47px;
    img {
      width: 315px;
      height: 316px;
      margin-bottom: 25px;
    }
    div {
      font-size: 20px;
      color: #447849;
    }
  }
}
.buy {
  width: 100%;
}
.buy_image {
  width: 100%;
  display: block;
}
</style>
